const config = {
    development: {
        activationEndpoint: 'http://127.0.0.1:8000/api-auth-djoser/users/activation/',
        loginEndpoint: "http://127.0.0.1:8000/api/login/", // ADR-compliant
        logoutEndpoint: "", // JWT doesn't need server-side logout by default
        myUserEndpoint: "http://127.0.0.1:8000/api-auth-djoser/users/me/",
        registerEndpoint: "http://127.0.0.1:8000/api-auth-djoser/users/",
        twoFALoginEndpoint: "http://127.0.0.1:8000/api/2fa/login/",
        enable2FAEndpoint: "http://127.0.0.1:8000/api/2fa/enable/",
        confirm2FAEndpoint: "http://127.0.0.1:8000/api/2fa/confirm/",
        twoFAStatusEndpoint: "http://127.0.0.1:8000/api/2fa/status/",
        disable2FAEndpoint: "http://127.0.0.1:8000/api/2fa/disable/",

        resetPasswordEndpoint: "http://127.0.0.1:8000/api-auth-djoser/users/reset_password/",
        resetPasswordConfirmEndpoint: "http://127.0.0.1:8000/api-auth-djoser/users/reset_password_confirm/",
        visitsEndpoint: "http://127.0.0.1:8000/api/visits/",

        // Get all
        propertiesEndpoint: "http://127.0.0.1:8000/api/properties/",
        carsEndpoint: "http://127.0.0.1:8000/api/cars/",
        builtHeritageEndpoint: "http://127.0.0.1:8000/api/built_heritage/",
        accommodationEndpoint: "http://127.0.0.1:8000/api/accommodation/",
        companiesEndpoint: "http://127.0.0.1:8000/api/profiles/",
        scientistsEndpoint: "http://127.0.0.1:8000/api/academia/",
        fieldsOfScienceEndpoint: "http://127.0.0.1:8000/api/fields_of_science/",
        parishEndpoint: (page = 1) => `http://127.0.0.1:8000/api/kozsegvaros/?page=${page}`,
        telepulesEndpoint: (page = 1) => `http://127.0.0.1:8000/api/telepules/?page=${page}`,
        szekEndpoint: (page = 1) => `http://127.0.0.1:8000/api/szek/?page=${page}`,
        megyeEndpoint: (page = 1) => `http://127.0.0.1:8000/api/megye/?page=${page}`,
        csangoKozsegVarosEndpoint: (page = 1) => `http://127.0.0.1:8000/api/csango-kozsegvaros/?page=${page}`,
        csangoTelepulesEndpoint: (page = 1) => `http://127.0.0.1:8000/api/csango-telepules/?page=${page}`,
        helynevEndpoint: (page = 1) => `http://127.0.0.1:8000/api/helynev/?page=${page}`,
        localityEndpoint: "http://127.0.0.1:8000/api/telepules/",
        geographicEndpoint: "http://127.0.0.1:8000/api/geographic/",
        newsLinksEndpoint: "http://127.0.0.1:8000/api/news-links/",
        deleteNewsLinkEndpoint: (id) => `http://127.0.0.1:8000/api/news-links/${id}/`,
        historyEndpoint: "http://127.0.0.1:8000/api/history/",
        mineralWaterEndpoint: "http://127.0.0.1:8000/api/mineral_waters/",
        getMineralWaterInfoEndpoint: (category, id) => `http://127.0.0.1:8000/api/mineral_waters/${category}/${id}/`,
        sportEndpoint: "http://127.0.0.1:8000/api/sport/",

        // Dropdown / check
        scientistIdWithFullNameEndpoint: "http://127.0.0.1:8000/api/scientists_fullname/",
        checkScientistEndpoint: "http://127.0.0.1:8000/api/academia/check/",

        // Create
        createPropertyEndpoint: "http://127.0.0.1:8000/api/properties/create/",
        createCarEndpoint: "http://127.0.0.1:8000/api/cars/create/",
        createScientistEndpoint: "http://127.0.0.1:8000/api/academia/create/",
        createPublicationEndpoint: "http://127.0.0.1:8000/api/publications/create/",

        // Detail
        getProfileEndpoint: (userId) => `http://127.0.0.1:8000/api/profiles/${userId}/`,
        getProfileInfoEndpoint: (sellerId) => `http://127.0.0.1:8000/api/profiles/${sellerId}/`,
        getPropertyInfoEndpoint: (paramsId) => `http://127.0.0.1:8000/api/properties/${paramsId}/`,
        getCarInfoEndpoint: (paramsId) => `http://127.0.0.1:8000/api/cars/${paramsId}/`,
        getScientistInfoEndpoint: (scientistId) => `http://127.0.0.1:8000/api/academia/${scientistId}/`,
        getPublicationsEndpoint: (clickedScientist) => `http://127.0.0.1:8000/api/publications/${clickedScientist}`,

        // Delete
        deletePropertyEndpoint: (paramsId) => `http://127.0.0.1:8000/api/properties/${paramsId}/delete/`,
        deleteCarEndpoint: (paramsId) => `http://127.0.0.1:8000/api/cars/${paramsId}/delete/`,
        deleteScientistEndpoint: (scientistId) => `http://127.0.0.1:8000/api/academia/${scientistId}/delete/`,
        deletePublicationEndpoint: (publicationId) => `http://127.0.0.1:8000/api/publications/${publicationId}/delete/`,
        deleteProfileEndpoint: (userId) => `http://127.0.0.1:8000/api/profiles/${userId}/delete/`,

        // Update
        getProfileUpdateEndpoint: (userId) => `http://127.0.0.1:8000/api/profiles/${userId}/update/`,
        getPropertyUpdateEndpoint: (listingId) => `http://127.0.0.1:8000/api/properties/${listingId}/update/`,
        getCarUpdateEndpoint: (listingId) => `http://127.0.0.1:8000/api/cars/${listingId}/update/`,
        getScientistUpdateEndpoint: (scientistId) => `http://127.0.0.1:8000/api/academia/${scientistId}/update/`,
        getPublicationUpdateEndpoint: (publicationId) => `http://127.0.0.1:8000/api/publications/${publicationId}/update/`,

        // Market Expansion
        sportEquipmentEndpoint: "http://127.0.0.1:8000/api/sport-equipment/",
        ownProduceEndpoint: "http://127.0.0.1:8000/api/own-produce/",
        producerCategoriesEndpoint: "http://127.0.0.1:8000/api/producer-categories/",
        marketplaceAccommodationEndpoint: "http://127.0.0.1:8000/api/marketplace-accommodation/",
        createMarketplaceAccommodationEndpoint: "http://127.0.0.1:8000/api/marketplace-accommodation/create/",
        deleteMarketplaceAccommodationEndpoint: (id) => `http://127.0.0.1:8000/api/marketplace-accommodation/${id}/delete/`,
        updateMarketplaceAccommodationEndpoint: (id) => `http://127.0.0.1:8000/api/marketplace-accommodation/${id}/update/`,
        businessesEndpoint: "http://127.0.0.1:8000/api/businesses/",
        businessAvailabilityEndpoint: "http://127.0.0.1:8000/api/business-availability/",
        businessBookingsEndpoint: "http://127.0.0.1:8000/api/business-bookings/",
        businessReviewsEndpoint: "http://127.0.0.1:8000/api/business-reviews/",
        advertisementsEndpoint: "http://127.0.0.1:8000/api/advertisements/",
        createAdvertisementEndpoint: "http://127.0.0.1:8000/api/advertisements/create/",
        szekelyfoldiEsemenyekEndpoint: "http://127.0.0.1:8000/api/szekelyfoldi-esemenyek/",
        createSzekelyfoldiEsemenyekEndpoint: "http://127.0.0.1:8000/api/szekelyfoldi-esemenyek/create/",
        deleteSzekelyfoldiEsemenyekEndpoint: (id) => `http://127.0.0.1:8000/api/szekelyfoldi-esemenyek/${id}/delete/`,
        refreshTokenEndpoint: "http://127.0.0.1:8000/api-auth-djoser/jwt/refresh/",
        apiEndpoint: "http://127.0.0.1:8000/",
        touristRoutesEndpoint: "http://127.0.0.1:8000/api/thematic-maps/tourist-routes/",
        runningRoutesEndpoint: "http://127.0.0.1:8000/api/thematic-maps/points/?category=running",
        createRunningRouteEndpoint: "http://127.0.0.1:8000/api/thematic-maps/running/create/",
        thematicPointsEndpoint: "http://127.0.0.1:8000/api/thematic-maps/points/",
        herbichGeoTiles: "http://127.0.0.1:8000/tiles/herbichgeo/{z}/{x}/{y}.png",
        nsznHonismeretiTiles: "http://127.0.0.1:8000/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        geo200000Tiles: "http://127.0.0.1:8000/tiles/geo200000/{z}/{x}/{y}.png",
        cyclOSMTiles: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
        osmTiles: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        familyTreeEndpoint: "http://127.0.0.1:8000/api/family-tree/",
        familySyncEndpoint: "http://127.0.0.1:8000/api/family-sync/",
    },
    production: {
        activationEndpoint: 'https://www.sznoapi.ro/api-auth-djoser/users/activation/',
        loginEndpoint: "https://www.sznoapi.ro/api/login/", // ADR-compliant
        logoutEndpoint: "", // JWT doesn't need server-side logout by default
        myUserEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/me/",
        registerEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/",
        twoFALoginEndpoint: "https://www.sznoapi.ro/api/2fa/login/",
        enable2FAEndpoint: "https://www.sznoapi.ro/api/2fa/enable/",
        confirm2FAEndpoint: "https://www.sznoapi.ro/api/2fa/confirm/",
        twoFAStatusEndpoint: "https://www.sznoapi.ro/api/2fa/status/",
        disable2FAEndpoint: "https://www.sznoapi.ro/api/2fa/disable/",

        resetPasswordEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/reset_password/",
        resetPasswordConfirmEndpoint: "https://www.sznoapi.ro/api-auth-djoser/users/reset_password_confirm/",
        visitsEndpoint: "https://www.sznoapi.ro/api/visits/",


        // Get all
        propertiesEndpoint: "https://www.sznoapi.ro/api/properties/",
        carsEndpoint: "https://www.sznoapi.ro/api/cars/",
        builtHeritageEndpoint: "https://www.sznoapi.ro/api/built_heritage/",
        accommodationEndpoint: "https://www.sznoapi.ro/api/accommodation/",
        companiesEndpoint: "https://www.sznoapi.ro/api/profiles/",
        scientistsEndpoint: "https://www.sznoapi.ro/api/academia/",
        fieldsOfScienceEndpoint: "https://www.sznoapi.ro/api/fields_of_science/",
        parishEndpoint: (page = 1) => `https://www.sznoapi.ro/api/kozsegvaros/?page=${page}`,
        telepulesEndpoint: (page = 1) => `https://www.sznoapi.ro/api/telepules/?page=${page}`,
        szekEndpoint: (page = 1) => `https://www.sznoapi.ro/api/szek/?page=${page}`,
        megyeEndpoint: (page = 1) => `https://www.sznoapi.ro/api/megye/?page=${page}`,
        csangoKozsegVarosEndpoint: (page = 1) => `https://www.sznoapi.ro/api/csango-kozsegvaros/?page=${page}`,
        csangoTelepulesEndpoint: (page = 1) => `https://www.sznoapi.ro/api/csango-telepules/?page=${page}`,
        helynevEndpoint: (page = 1) => `https://www.sznoapi.ro/api/helynev/?page=${page}`,
        localityEndpoint: "https://www.sznoapi.ro/api/telepules/",
        geographicEndpoint: "https://www.sznoapi.ro/api/geographic/",
        newsLinksEndpoint: "https://www.sznoapi.ro/api/news-links/",
        deleteNewsLinkEndpoint: (id) => `https://www.sznoapi.ro/api/news-links/${id}/`,
        historyEndpoint: "https://www.sznoapi.ro/api/history/",
        mineralWaterEndpoint: "https://www.sznoapi.ro/api/mineral_waters/",
        getMineralWaterInfoEndpoint: (category, id) => `https://www.sznoapi.ro/api/mineral_waters/${category}/${id}/`,
        sportEndpoint: "https://www.sznoapi.ro/api/sport/",

        // Dropdown / check
        scientistIdWithFullNameEndpoint: "https://www.sznoapi.ro/api/scientists_fullname/",
        checkScientistEndpoint: "https://www.sznoapi.ro/api/academia/check/",

        // Create
        createPropertyEndpoint: "https://www.sznoapi.ro/api/properties/create/",
        createCarEndpoint: "https://www.sznoapi.ro/api/cars/create/",
        createScientistEndpoint: "https://www.sznoapi.ro/api/academia/create/",
        createPublicationEndpoint: "https://www.sznoapi.ro/api/publications/create/",

        // Detail
        getProfileEndpoint: (userId) => `https://www.sznoapi.ro/api/profiles/${userId}/`,
        getProfileInfoEndpoint: (sellerId) => `https://www.sznoapi.ro/api/profiles/${sellerId}/`,
        getPropertyInfoEndpoint: (paramsId) => `https://www.sznoapi.ro/api/properties/${paramsId}/`,
        getCarInfoEndpoint: (paramsId) => `https://www.sznoapi.ro/api/cars/${paramsId}/`,
        getScientistInfoEndpoint: (scientistId) => `https://www.sznoapi.ro/api/academia/${scientistId}/`,
        getPublicationsEndpoint: (clickedScientist) => `https://www.sznoapi.ro/api/publications/${clickedScientist}`,

        // Delete
        deletePropertyEndpoint: (paramsId) => `https://www.sznoapi.ro/api/properties/${paramsId}/delete/`,
        deleteCarEndpoint: (paramsId) => `https://www.sznoapi.ro/api/cars/${paramsId}/delete/`,
        deleteScientistEndpoint: (scientistId) => `https://www.sznoapi.ro/api/academia/${scientistId}/delete/`,
        deletePublicationEndpoint: (publicationId) => `https://www.sznoapi.ro/api/publications/${publicationId}/delete/`,
        deleteProfileEndpoint: (userId) => `https://www.sznoapi.ro/api/profiles/${userId}/delete/`,

        // Update
        getProfileUpdateEndpoint: (userId) => `https://www.sznoapi.ro/api/profiles/${userId}/update/`,
        getPropertyUpdateEndpoint: (listingId) => `https://www.sznoapi.ro/api/properties/${listingId}/update/`,
        getCarUpdateEndpoint: (listingId) => `https://www.sznoapi.ro/api/cars/${listingId}/update/`,
        getScientistUpdateEndpoint: (scientistId) => `https://www.sznoapi.ro/api/academia/${scientistId}/update/`,
        getPublicationUpdateEndpoint: (publicationId) => `https://www.sznoapi.ro/api/publications/${publicationId}/update/`,

        // Market Expansion
        sportEquipmentEndpoint: "https://www.sznoapi.ro/api/sport-equipment/",
        ownProduceEndpoint: "https://www.sznoapi.ro/api/own-produce/",
        producerCategoriesEndpoint: "https://www.sznoapi.ro/api/producer-categories/",
        marketplaceAccommodationEndpoint: "https://www.sznoapi.ro/api/marketplace-accommodation/",
        createMarketplaceAccommodationEndpoint: "https://www.sznoapi.ro/api/marketplace-accommodation/create/",
        deleteMarketplaceAccommodationEndpoint: (id) => `https://www.sznoapi.ro/api/marketplace-accommodation/${id}/delete/`,
        updateMarketplaceAccommodationEndpoint: (id) => `https://www.sznoapi.ro/api/marketplace-accommodation/${id}/update/`,
        businessesEndpoint: "https://www.sznoapi.ro/api/businesses/",
        businessAvailabilityEndpoint: "https://www.sznoapi.ro/api/business-availability/",
        businessBookingsEndpoint: "https://www.sznoapi.ro/api/business-bookings/",
        businessReviewsEndpoint: "https://www.sznoapi.ro/api/business-reviews/",
        advertisementsEndpoint: "https://www.sznoapi.ro/api/advertisements/",
        createAdvertisementEndpoint: "https://www.sznoapi.ro/api/advertisements/create/",
        szekelyfoldiEsemenyekEndpoint: "https://www.sznoapi.ro/api/szekelyfoldi-esemenyek/",
        createSzekelyfoldiEsemenyekEndpoint: "https://www.sznoapi.ro/api/szekelyfoldi-esemenyek/create/",
        deleteSzekelyfoldiEsemenyekEndpoint: (id) => `https://www.sznoapi.ro/api/szekelyfoldi-esemenyek/${id}/delete/`,
        refreshTokenEndpoint: "https://www.sznoapi.ro/api-auth-djoser/jwt/refresh/",
        apiEndpoint: "https://www.sznoapi.ro/",
        touristRoutesEndpoint: "https://www.sznoapi.ro/api/thematic-maps/tourist-routes/",
        runningRoutesEndpoint: "https://www.sznoapi.ro/api/thematic-maps/points/?category=running",
        createRunningRouteEndpoint: "https://www.sznoapi.ro/api/thematic-maps/running/create/",
        thematicPointsEndpoint: "https://www.sznoapi.ro/api/thematic-maps/points/",
        herbichGeoTiles: "https://www.sznoapi.ro/tiles/herbichgeo/{z}/{x}/{y}.png",
        nsznHonismeretiTiles: "https://www.sznoapi.ro/tiles/nsznhonismereti/{z}/{x}/{y}.png",
        geo200000Tiles: "https://www.sznoapi.ro/tiles/geo200000/{z}/{x}/{y}.png",
        cyclOSMTiles: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
        osmTiles: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        familyTreeEndpoint: "https://www.sznoapi.ro/api/family-tree/",
        familySyncEndpoint: "https://www.sznoapi.ro/api/family-sync/",
    }
};

export const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development';
export default config;
